module.exports = __webpack_public_path__ + "img/Ausgefüllter_Raum_Schichtung.b83fa1d9.svg";